export const PORTING_ACCOUNT_TYPE = [
    { name: 'Postpay single line', value: 'BILL_PAY_SINGLE_LINE' },
    { name: 'Postpay multiline', value: 'BILL_PAY_MULTI_LINE' },
    { name: 'Prepay registered', value: 'PAYG_REGISTERED' },
    { name: 'Prepay unregistered', value: 'PAYG_UNREGISTERED' },
    { name: 'Prepay multiline', value: 'PAYG_MULTI_LINE' },
];
export const PREPAY_PLAN_URL = '/mobile/prepay/';
export const PREPAY_PHONES_URL = '/store/mobile/phones/prepay/';
export const PREPAY_REVIEW_URL = '/checkout/review/';
export const CONTRACT_SUMMARY_LINK = 'https://www.eir.ie/prepaysummary';